import FieldRenderer from "../global/forms/FieldRenderer";
import dataConstants from "../../constants/dataConstants";
import EditProfileFieldsProps from "../../services/models/formModels/editProfileFieldsForm.model";
import CustomTextInputProps from "../../services/models/customTextInputProps.mode";

function EditProfileFields({
  touched,
  errors,
  handleChange,
  handleBlur,
  showPhysicianFields,
  values,
  getFieldMeta
}: EditProfileFieldsProps): JSX.Element {
  return (
    <FieldRenderer
      fields={dataConstants.editProfileFields
        .filter((field) => {
          if (!showPhysicianFields) {
            return (
              ["npi", "suffix", "specialty"].includes(field?.name ?? "") ===
              false
            );
          }
          return true;
        })
        .map((field, index) => ({
          key: `${index}${(field as CustomTextInputProps).labelInfo?.inputId}`,
          ...field,
          errors: errors,
          touched: touched,
          onChange: handleChange,
          value: values?.[!!field?.name ? field.name : ""],
          onBlur: handleBlur,
          name: field.name,
          getFieldMeta: getFieldMeta,
          roundedInput: true,
        }))}
    />
  );
}

export default EditProfileFields;
